import $ from 'jquery'
export default {
  install(Vue, options) {
    Vue.prototype.$goPage = function(url) {
      if (url) {
        if(url.indexOf('http')>=0){
          window.open(url,'_blank');
          return
        }
        let isHuawei = navigator.userAgent.toLowerCase().match(/huawei/i) == "huawei";
        if(isHuawei){
          window.location.href='/#'+url;
        }else{
          this.$router.push({
            path: url
          })
        }
      }
    }
    Vue.prototype.$scroll = function() {
      let scrollTop = document.querySelector("#app").scrollTop;
      let showArr = [false, false, scrollTop]
      if (window.scrollTop - scrollTop > 0) {
        showArr[0] = true;
      } else {
        showArr[0] = false;
      }
      window.scrollTop = scrollTop
      if (scrollTop > window.h / 2) {
        showArr[1] = true;
      } else {
        showArr[1] = false;
      }
      return showArr;
    }
    Vue.prototype.$scrollToTop = function(time,top,id) {
      id = id?id:'#app';
      $(id).stop().animate({
        scrollTop: top
      }, time);
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/allJs.js